import { __assign, __extends } from "tslib";
import React from 'react';
import { DOMSerializer, } from 'prosemirror-model';
import ReactNodeView from '../../../nodeviews/ReactNodeView';
import { generateColgroup } from '../pm-plugins/table-resizing/utils';
import TableComponent from './TableComponent';
import WithPluginState from '../../../ui/WithPluginState';
import { pluginKey as widthPluginKey } from '../../width';
import { pluginKey as tableResizingPluginKey } from '../pm-plugins/table-resizing/index';
import { getPluginState, pluginKey } from '../pm-plugins/plugin-factory';
import { pluginConfig as getPluginConfig } from '../create-plugin-config';
var tableAttributes = function (node) {
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
    };
};
var toDOM = function (node, props) {
    var colgroup = '';
    if (props.allowColumnResizing) {
        // @ts-ignore
        colgroup = ['colgroup', {}].concat(generateColgroup(node));
    }
    return [
        'table',
        tableAttributes(node),
        colgroup,
        ['tbody', 0],
    ];
};
var TableView = /** @class */ (function (_super) {
    __extends(TableView, _super);
    function TableView(props) {
        var _this = _super.call(this, props.node, props.view, props.getPos, props.portalProviderAPI, props) || this;
        _this.getPos = props.getPos;
        return _this;
    }
    TableView.prototype.getContentDOM = function () {
        var rendered = DOMSerializer.renderSpec(document, toDOM(this.node, this.reactComponentProps));
        if (rendered.dom) {
            this.table = rendered.dom;
        }
        return rendered;
    };
    TableView.prototype.setDomAttrs = function (node) {
        var _this = this;
        if (!this.table) {
            return;
        }
        var attrs = tableAttributes(node);
        Object.keys(attrs).forEach(function (attr) {
            _this.table.setAttribute(attr, attrs[attr]);
        });
    };
    TableView.prototype.render = function (props, forwardRef) {
        var _this = this;
        return (React.createElement(WithPluginState, { plugins: {
                containerWidth: widthPluginKey,
                pluginState: pluginKey,
                tableResizingPluginState: tableResizingPluginKey,
            }, editorView: props.view, render: function (pluginStates) { return (React.createElement(TableComponent, __assign({}, props, pluginStates, { node: _this.node, width: pluginStates.containerWidth.width, contentDOM: forwardRef }))); } }));
    };
    TableView.prototype.ignoreMutation = function () {
        return true;
    };
    return TableView;
}(ReactNodeView));
export default TableView;
export var createTableView = function (node, view, getPos, portalProviderAPI, options) {
    var pluginConfig = getPluginState(view.state).pluginConfig;
    var allowColumnResizing = getPluginConfig(pluginConfig).allowColumnResizing;
    return new TableView({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        portalProviderAPI: portalProviderAPI,
        getPos: getPos,
        options: options,
    }).init();
};
//# sourceMappingURL=table.js.map